import axios from "common/helpers/axios.helper"

export const setContainerList = (containerList) => {
    return {
        type: "SET_CONTAINER_LIST",
        payload: containerList
    }
}

export const setDownloadList = (downloadList) => {
    return {
        type: "SET_DOWNLOAD_LIST",
        payload: downloadList
    }
}

export const getContainerList = () => {
    return (dispatch, getState) => {
        const { apiURL, token } = getState().app;

        dispatch({ type: 'CONTAINER_LIST_PENDING' });

        axios({
            url: encodeURI(apiURL + `/api/v1/containers/`),
            method: 'GET',
            responseType: 'json',
            timeout: 10 * 1000,
            headers: { 'authorization': token, 'Content-Type': 'application/json' }
        }).then((response) => {
            dispatch({ type: 'CONTAINER_LIST_SUCCESS', payload: response.data });
        }).catch((error) => {
            dispatch({ type: 'CONTAINER_LIST_ERROR', payload: error.response })
        });
    }
}

export const getContainerListPromise = () => {
    return (dispatch, getState) => {
        const { apiURL, token } = getState().app;

        const requestPromise = new Promise(function (resolve, reject) {

            dispatch({ type: 'CONTAINER_LIST_PENDING' });

            axios({
                url: encodeURI(apiURL + `/api/v1/containers/`),
                method: 'GET',
                responseType: 'json',
                timeout: 10 * 1000,
                headers: { 'authorization': token, 'Content-Type': 'application/json' }
            }).then((response) => {
                dispatch({ type: 'CONTAINER_LIST_SUCCESS', payload: response.data });
                resolve(response.data)
            }).catch((error) => {
                dispatch({ type: 'CONTAINER_LIST_ERROR', payload: error.response });
                reject(error);
            });
        })
        return requestPromise
    }
}
